import module from 'nominas/nomina/module.js'
import template from './template.html'
import { extend } from 'angular'

export default class NominasNominaBancosPagosEmpleadoPagosComponent {
  constructor (NominasNominaBancosPagos, $dialog, $scope) {
    this.NominasNominaBancosPagos = NominasNominaBancosPagos
    this.$dialog = $dialog
    this.$scope = $scope
    this.procesando = false
    this.idNomina = null
    this.idEmpresa = null
    this.idEmpleado = null
    this.data = null
    this.nomina = null
    this.formasPago = {
      '01': 'Transferencia',
      '02': 'Cheque',
      '03': 'Efectivo',
      '04': 'Retención',
      '05': 'Otro',
    }
  }

  $onInit () {
    this.$scope.$watchCollection(() => this.data.Pagos, () => this.calcular())
    this.calcular()
  }

  eliminar (item) {
    this.$dialog.confirm('¿Desea eliminar este pago?')
      .then(() => {
        this.procesando = true

        this.NominasNominaBancosPagos.remove(this.idNomina, this.idEmpresa, this.idEmpleado, item.Indice)
          .then(() => {
            this.data.Pagos.splice(this.data.Pagos.indexOf(item), 1)
            this.pago = null
            this.onActualizar()
          })
          .finally(() => (this.procesando = false))
      })
  }

  agregar () {
    this.pago = {
      Indice: null,
      Fecha_Pago: this.nomina.Fecha_Pago,
      Importe: this.totalFaltante,
      OP_ID_Empresa: this.nomina.OP_ID_Empresa,
      ID_Cuenta: this.nomina.ID_Moneda === '1' ? this.nomina.OP_ID_Cuenta_MXN : this.nomina.OP_ID_Cuenta_USD,
      ID_Moneda: this.nomina.ID_Moneda,
      Banco: undefined,
      Numero_Cuenta: undefined,
      Tipo_Cambio: this.nomina.Tipo_Cambio,
      Forma_Pago: '01',
      Referencia: '',
      Notas: '',
    }
  }

  calcular () {
    let totalCapturado = this.data.Pagos.reduce((prev, next) => prev + next.Importe, 0)

    this.totalCapturado = parseFloat(totalCapturado.toFixed(2))
    this.totalFaltante = Math.abs(this.data.Total_Pagar - this.totalCapturado)
  }

  cerrar () {
    this.onCerrar()
  }

  editar (item) {
    this.pago = item
  }

  actualizar (data) {
    if (!this.pago || this.procesando) return

    this.procesando = true

    return this.NominasNominaBancosPagos.update(this.idNomina, this.idEmpresa, this.idEmpleado, this.pago.Indice, data)
      .then((data) => {
        if (this.pago.Indice) {
          extend(this.pago, data)
        } else {
          this.data.Pagos.unshift(data)
        }

        this.calcular()
        this.onActualizar()
      })
      .finally(() => {
        this.pago = null
        this.procesando = false
      })
  }
}

module.component('nominasNominaBancosPagosEmpleadoPagos', {
  controller: NominasNominaBancosPagosEmpleadoPagosComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idEmpleado: '<',
    idNomina: '<',
    nomina: '<',
    data: '<',
    onActualizar: '&',
    onCerrar: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/pagos/empleado/pagos/component.js